export default __webpack_public_path__ + "static/main-video02-b8684b819c3833cf0dbf19b2fa8ea846.jpg";